export { default } from './SubmitBox';



// WEBPACK FOOTER //
// ./src/components/write/SubmitBox/index.js